import React from "react";
import { useTranslation } from "react-i18next";

function JournalInfo({ doc }) {
  const { t } = useTranslation();
  return (
    <>
      <div>
        {t("requests.preview.journal.info.email")}:{" "}
        <a href={"mailto:info@hkms.hr?subject=&body="}>info@hkms.hr</a>
      </div>
      <div>{t("requests.preview.journal.info.mobile")}: +385918741985</div>
    </>
  );
}
export default JournalInfo;
